import { COLOR, Button as _Button, mq, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const ArticleRootWrapper = styled.article`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-top: 1px solid ${COLOR.GRAY200.code};

  &:first-of-type {
    border-top: 0px;
  }

  &:last-of-type {
    border-bottom: 1px solid ${COLOR.GRAY200.code};
  }
`;

export const DivTagWrapper = styled.div`
  display: grid;
  grid-gap: 8px;
  padding-right: 16px;
`;

export const SpanPerformanceText = styled.span`
  color: ${COLOR.GRAY900.code};
  font-weight: ${FONT_WEIGHT.BOLD};

  ${mq.sp} {
    font-size: 14px;
  }
`;

export const ParPurchasedText = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${COLOR.GRAY500.code};
  font-size: 16px;
  font-weight: ${FONT_WEIGHT.BOLD};
  min-width: 320px;

  ${mq.sp} {
    min-width: 120px;
    font-size: 14px;
  }
`;

export const Button = styled(_Button)`
  font-size: 16px;
  min-width: 320px;

  ${mq.sp} {
    font-size: 14px;
    min-width: 120px;
  }
`;
